function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect, useMemo } from 'react';
import { arrayOf, func, object, shape, string, oneOf, bool } from 'prop-types';
import { TextField, Button, SelectField, Icon } from '@unite-us/ui';
import LanguageSelector from '@unite-us/client-utils/dist/consent/LanguageSelector';
import { Form } from 'react-final-form';
import { debounce } from 'lodash';
import { SHARE_METHODS, RESOURCE_TYPES, SENSITIVE_PROGRAMS, PLACEHOLDER_TEXT, SENSITIVE_PROGRAM_SUPPORT_MESSAGES } from '../../constants';
import ShareMethodField from './ShareMethodField';
import ShareToField from './ShareToField';
import { AddressOptionGroupProps, addressPropType } from '../../propTypes';
import { getGeoAddressOptions } from '../../utils/geocode';
export default function ShareForm(_ref) {
  var address = _ref.address,
    addressOptions = _ref.addressOptions,
    coreApi = _ref.coreApi,
    defaultAddressOptions = _ref.defaultAddressOptions,
    initialValues = _ref.initialValues,
    message = _ref.message,
    onPrint = _ref.onPrint,
    _onSubmit = _ref.onSubmit,
    resourceType = _ref.resourceType,
    sensitivePrograms = _ref.sensitivePrograms,
    setAddress = _ref.setAddress,
    setAddressOptions = _ref.setAddressOptions,
    setMessage = _ref.setMessage,
    showMessageBox = _ref.showMessageBox;
  var _useState = useState('en'),
    _useState2 = _slicedToArray(_useState, 2),
    language = _useState2[0],
    setLanguage = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    hintText = _useState4[0],
    setHintText = _useState4[1];
  var uniqueId = useMemo(function () {
    return Math.random().toString(16).slice(2);
  }, []);
  useEffect(function () {
    if (sensitivePrograms === SENSITIVE_PROGRAMS.SOME) {
      setHintText(SENSITIVE_PROGRAM_SUPPORT_MESSAGES.SOME);
    } else if (sensitivePrograms === SENSITIVE_PROGRAMS.ALL) {
      setHintText(SENSITIVE_PROGRAM_SUPPORT_MESSAGES.ALL);
    } else {
      setHintText('');
    }
  }, [sensitivePrograms]);

  // TODO : Review use of debounce here
  var loadAddressOptions = debounce(function (query) {
    getGeoAddressOptions(query, defaultAddressOptions, setAddressOptions, coreApi);
  }, 400);
  return /*#__PURE__*/React.createElement(Form, {
    initialValues: initialValues,
    onSubmit: function onSubmit(values) {
      return _onSubmit(_objectSpread(_objectSpread({}, values), {}, {
        language: language
      }));
    }
  }, function (_ref2) {
    var handleSubmit = _ref2.handleSubmit,
      submitting = _ref2.submitting,
      invalid = _ref2.invalid,
      shareMethod = _ref2.values.shareMethod;
    return /*#__PURE__*/React.createElement("form", {
      className: "share-form share-drawer__share-form",
      id: "network-browse-share-drawer-".concat(uniqueId)
    }, /*#__PURE__*/React.createElement(ShareMethodField, {
      shareMethod: shareMethod,
      uniqueId: uniqueId
    }), /*#__PURE__*/React.createElement(SelectField, {
      id: "addressDropdown-".concat(uniqueId),
      valueKey: "id",
      labelKey: "name",
      placeholder: "Select an address",
      searchPlaceholderValue: "Search for an address not listed below",
      shouldSort: false,
      dataTestElement: "addressDropdown",
      value: address,
      onChange: setAddress,
      label: "Address",
      options: addressOptions,
      className: "mb-4",
      clearable: false,
      hideError: true,
      hideHint: true,
      loadOptions: loadAddressOptions
    }), [SHARE_METHODS.EMAIL, SHARE_METHODS.PHONE].includes(shareMethod) && /*#__PURE__*/React.createElement(ShareToField, {
      shareMethod: shareMethod
    }), /*#__PURE__*/React.createElement("div", null, showMessageBox && RESOURCE_TYPES.program === resourceType && [SHARE_METHODS.EMAIL, SHARE_METHODS.PHONE].includes(shareMethod) && /*#__PURE__*/React.createElement("div", null, !!hintText && /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row"
    }, /*#__PURE__*/React.createElement(Icon, {
      icon: "IconExclamationCircle",
      className: "mr-2"
    }), /*#__PURE__*/React.createElement("p", null, hintText)), /*#__PURE__*/React.createElement(TextField, {
      cols: 40,
      id: "share-message-".concat(uniqueId),
      label: "Message",
      value: message,
      maxLength: 400,
      onChange: function onChange(e) {
        setMessage(e.target.value);
      },
      disabled: sensitivePrograms === SENSITIVE_PROGRAMS.ALL,
      className: "mt-2 mb-2",
      placeholder: PLACEHOLDER_TEXT
    }))), /*#__PURE__*/React.createElement("div", {
      className: "pb-3"
    }, /*#__PURE__*/React.createElement(LanguageSelector, {
      onChange: setLanguage,
      field: {
        value: language
      },
      appContext: "shares",
      theme: {
        width: 'flex'
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "share-form__buttons"
    }, shareMethod === SHARE_METHODS.PRINT ? /*#__PURE__*/React.createElement(Button, {
      id: "share-print-button-".concat(uniqueId),
      disabled: submitting || invalid,
      label: "Print",
      onClick: function onClick() {
        return onPrint(language);
      },
      primary: true
    }) : /*#__PURE__*/React.createElement(Button, {
      id: "share-send-button-".concat(uniqueId),
      disabled: submitting || invalid,
      onClick: handleSubmit,
      label: "Send",
      primary: true,
      type: "submit"
    })));
  });
}
ShareForm.defaultProps = {
  initialValues: {
    shareMethod: SHARE_METHODS.PHONE
  },
  address: {},
  addressOptions: [],
  setAddressOptions: function setAddressOptions() {
    return null;
  },
  message: '',
  defaultAddressOptions: [],
  coreApi: null,
  setAddress: function setAddress() {
    return null;
  },
  showMessageBox: false
};
ShareForm.propTypes = {
  onPrint: func.isRequired,
  onSubmit: func.isRequired,
  initialValues: shape({
    shareMethod: string
  }),
  addressOptions: arrayOf(AddressOptionGroupProps),
  setAddressOptions: func,
  message: string,
  setMessage: func.isRequired,
  defaultAddressOptions: arrayOf(AddressOptionGroupProps),
  address: shape(addressPropType),
  setAddress: func,
  coreApi: shape({
    http: func,
    // eslint-disable-next-line react/forbid-prop-types
    serializer: object
  }),
  resourceType: oneOf(Object.values(RESOURCE_TYPES)).isRequired,
  sensitivePrograms: oneOf(Object.values(SENSITIVE_PROGRAMS)).isRequired,
  showMessageBox: bool
};
//# sourceMappingURL=ShareForm.js.map